import React from 'react';

import { type SupportedChain } from '@pkg/types';
import { capitalizeFirstLetter } from '@pkg/utils';

import AptosSvg from '../../svg/aptos.svg?react';
import EthereumSvg from '../../svg/ethereum.svg?react';
import PolygonSvg from '../../svg/polygon.svg?react';

import { Wrapper } from './styles';

interface CurrencyIconProps {
    chain?: SupportedChain;
}

const icons = {
    polygon: PolygonSvg,
    aptos: AptosSvg,
    ethereum: EthereumSvg,
};
export const CurrencyIcon = ({ chain = 'ethereum' }: CurrencyIconProps) => {
    const IconComponent = icons[chain];
    return (
        <Wrapper initial={{ opacity: 0, scale: 0 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0 }}>
            <IconComponent title={capitalizeFirstLetter(chain)} />
        </Wrapper>
    );
};
